export const EVENT_CATEGORIES = {
  critico: { label: "Crítico" },
  conduccion: { label: "Conducción" },
  energia: { label: "Energía" },
  motor: { label: "Motor" },
  movimiento: { label: "Movimiento" },
  geocerca: { label: "Geocerca" },
  carga: { label: "Carga y sensores" },
  medicion: { label: "Medición" },
  otro: { label: "Otro" },
} as const;

export type EventCategory = keyof typeof EVENT_CATEGORIES;

const CATEGORY_BY_CODE = {
  1: "conduccion",
  2: "critico",
  3: "motor",
  4: "motor",
  5: "critico",
  6: "otro",
  7: "carga",
  8: "carga",
  9: "energia",
  10: "carga",
  11: "carga",
  12: "otro",
  13: "otro",
  14: "carga",
  15: "carga",
  16: "motor",
  17: "motor",
  18: "energia",
  19: "energia",
  20: "medicion",
  21: "medicion",
  22: "energia",
  23: "geocerca",
  24: "geocerca",
  25: "conduccion",
  26: "movimiento",
  27: "movimiento",
  28: "movimiento",
  29: "energia",
  30: "energia",
  31: "carga",
  32: "carga",
  33: "carga",
  34: "conduccion",
  35: "conduccion",
  36: "critico",
  37: "carga",
  38: "movimiento",
  40: "medicion",
  41: "medicion",
  42: "movimiento",
  43: "otro",
  44: "otro",
  45: "critico",
  46: "otro",
  47: "critico",
} as const satisfies Record<number, EventCategory>;

export const resolveEventCategory = (eventCode: number | null): EventCategory => {
  if (eventCode == null) return "otro";
  return CATEGORY_BY_CODE[eventCode as keyof typeof CATEGORY_BY_CODE] ?? "otro";
};
